/**
 * The rows a list shows: the records we work with, and the inactive ones only once somebody
 * asks for them — a carrier's fleet first (TRKC-107), every list since TRKC-110 item 2.
 *
 * An inactive record is history: kept, linked and still judged. Shown among the ones in use,
 * it read like one more truck short of its papers; Hugo filed a registration on two of them
 * before asking what was wrong (2026-10-13).
 */
export function rowsShown<T extends { active: boolean }>(rows: readonly T[], showInactive: boolean): T[] {
  return showInactive ? [...rows] : rows.filter((row) => row.active)
}

/**
 * The rows in the order they came, the active ones first: a book answers by name, inactive ones
 * among the rest when a search finds them, and history stays after what is in use (TRKC-110).
 * A column sorted afterwards keeps the split through its table's rank.
 */
export function withActiveFirst<T extends { active: boolean }>(rows: readonly T[]): T[] {
  return [...rows.filter((row) => row.active), ...rows.filter((row) => !row.active)]
}

/** How many of a list's rows are inactive: what its button says it holds back. */
export function inactiveCount(rows: readonly { active: boolean }[]): number {
  return rows.filter((row) => !row.active).length
}
